<template lang="pug">
  v-container(grid-list-xl fluid)
    ExtradruckVorlagenEdit(v-model="editId" @reload="$apollo.queries.druckVorlagen.refetch()" :url2pdfHost="url2pdfHost")
    v-btn(@click="createVorlage")
      v-icon add
      | Neu
    v-layout(wrap)
      v-flex(xs12 md9 lg10)
        v-data-table.elevation-1(
          v-model="selected"
          select-allX
          :headers="headers"
          :items="druckVorlagen"
          must-sortX
          :pagination="queryFilterPagination"
          @update:pagination="queryFilterPaginationUpdate($event)"
          :total-items="druckVorlagenCount"
          :loading="$apollo.queries.druckVorlagen.loading"
          :rows-per-page-items="[10,25,50,100,500,{text: 'Alle', value: -1}]"
          rows-per-page-text="Zeilen pro Seite:"
          no-data-text="Keine Druckvorlagen"
        )
          template(slot="items" slot-scope="{ selected, item }")
            td: v-btn(@click="editId = item.id" icon): v-icon edit
            td {{item.name}}
            td {{item.slug}}
            td {{item.artHuman}}

      v-flex(xs12 md3 lg2)
        v-card
          v-card-text
            v-text-field(label="Name" :value="$route.query.name" @input="queryFilterUpdate('name', $event)")
            v-text-field(label="Slug" :value="$route.query.slug" @input="queryFilterUpdate('slug', $event)")
            //- radio-group(label="Dringlichkeit" row :items="dringlichkeiten" :value="$route.query.dringlichkeit" @change="queryFilterUpdate('dringlichkeit', $event)")
            //- radio-group(label="Status" row :items="statenFilter" :value="$route.query.status" @change="queryFilterUpdate('status', $event)")

</template>

<script>
import gql from 'graphql-tag'
import queryFilter from '../../mixins/query-filter'
import ExtradruckVorlagenEdit from "./extra-druck-vorlagen-edit.vue";

export default {
  props: ['extra'],
  mixins: [queryFilter],
  components: {
    ExtradruckVorlagenEdit
  },
  data() {
    return {
      currentUser: null,
      editId: null,
      html: null,
      printUeberweisungData: null,
      printPatientenverfuegungData: null,
      selected: [],
      druckVorlagenCount: 0,
      druckVorlagen: [],
      headers: [
        { text: "", sortable: false },
        { text: "Name", sortable: false },
        { text: "Slug", sortable: false },
        { text: "Art", sortable: false },
      ],
      dringlichkeiten: [
        { text: "Alle", value: null },
        { text: "Normal", value: "normal" },
        { text: "Dringend", value: "dringend" },
      ],
      staten: [
        { text: "Neu", value: "neu" },
        { text: "In Bearbeitung", value: "in_bearbeitung" },
        { text: "Abgeschlossen", value: "abgeschlossen" },
      ],
      statenFilter: [
        { text: "Alle", value: null },
        { text: "Neu", value: "neu" },
        { text: "In Bearbeitung", value: "in_bearbeitung" },
        { text: "Abgeschlossen", value: "abgeschlossen" },
      ]
    }
  },
  apollo: {
    url2pdfHost: gql`{ url2pdfHost }`,
    druckVorlagen: {
      query: gql`query ExtradruckVorlagenVue($where: DruckVorlageWhereInput) {
        druckVorlagen(order: "slug", where: $where) {
          id
          name
          slug
          artHuman
          custom
        }
        druckVorlagencount(where: $where)
      }`,
      fetchPolocy: 'network-only',
      variables() {
        return { where: this.query }
      },
      skip() {
        return !this.rollen.length
      },
      update(response) {
        this.druckVorlagenCount = response.druckVorlagenCount
        return response.druckVorlagen
      }
    },
    currentUser: {
      query: gql`query ExtradruckVorlagenEditVue {
        currentUser {
          id
          vorname
          nachname
          rollen
        }
      }`
    },
  },
  computed: {
    data() {
      return JSON.parse(this.druckVorlagen && this.druckVorlagen[0] && this.druckVorlagen[0].data || null)
    },
    query() {
      const f = this.$route.query
      const rollen = this.rollen
      const q = { }
      if (f.name) {
        q.nameContains = f.name
      }
      if (f.slug) {
        q.slugContains = f.slug
      }
      if(rollen.indexOf('patientenverfuegung') > -1 && !rollen.indexOf('admin') > -1){
        q.artIn = ["pv"]
      }
      return q
    },
    rollen() {
      const currentUser = this.currentUser
      return currentUser && currentUser.rollen || []
    }
  },
  methods: {
    printUeberweisung(item) {
      this.printUeberweisungData = item
      this.$nextTick(async () => {
        let html = this.$refs.printUeberweisung.$el.innerHTML
        html = html.replace(/style-workaround/g, 'style')
        html = `<html><head><meta charset="utf-8"/></had><body>${html}</body></html>`
        this.html = html
        const resp = await this.$http.post(`${this.url2pdfHost}/api/render`, { html: html, pdf: { width: "14.8cm", height: "10.5cm" } }, { responseType: 'blob', headers: { "Content-Type": "application/json" } })
        const blob = await resp.blob()
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      })
    },
    printPatientenverfuegung(item) {
      this.printPatientenverfuegungData = null
      this.$nextTick(() => {
        this.printPatientenverfuegungData = item
      })
    },
    async printComponent(component, pageSize) {
        let html = component.$el.innerHTML
        html = html.replace(/style-workaround/g, 'style')
        html = `<html><head><meta charset="utf-8"/></had><body>${html}</body></html>`
        this.html = html
        const resp = await this.$http.post(`${this.url2pdfHost}/api/render`, { html: html, pdf: { format: "A4" } }, { responseType: 'blob', headers: { "Content-Type": "application/json" } })
        const blob = await resp.blob()
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
    },
    download(name, ext, type, content) {
      const url = window.URL.createObjectURL(new Blob([content], { type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${name.replace(/[^a-z0-9äüöß_ -]+/gi, '-').replace(/-+/, '-').replace(/^-+|-+$/g, '')}.${ext}`)
      document.body.appendChild(link)
      link.click()
    },
    createVorlage() {
      this.editId = 'neu'
    }
  },
}
</script>
